<template lang="pug">
  .page-game.page
    PageHead

    .page__content
      .page-game__banner(v-if="showBanner")
        img.page-game__banner-logo--top(
          :src='require("~/assets/img/betfury-logo.svg")',
          alt="BetFury logo"
        )
        .page-game__banner-title(v-t="'betFuryPagesBannerText'")
        Button.page-game__banner-button(v-t="'participate'" is-primary @click="goToBetFury")
        img.page-game__banner-background(:src='require("~/assets/img/betfury-banner-background.png")')
        img.page-game__banner-logo--right(:src="require('~/assets/img/BetFury_logo_vertical_color_on_dark.png')")

      .page-game__game-container(v-if="gameContainer")
        iframe(:src="gameContainer" frameborder="0" width="100%" :height="isMobile ? '100%' : '700px'")

      .page-game__about(v-if="gameAbout")
        .page-game__about-left
          .page-game__about-title
            | {{ gameTitle }}
          .page-game__about-text
            | {{ gameText }}
          template(v-if="gameLinks && (gameLinks.android || gameLinks.ios || gameLinks.steam || gameLinks.direct)")
            .page-game__about-links-title(v-if="gameLinks && (gameLinks.ios || gameLinks.android)" v-t="'loadGameToPhone'")
            .page-game__about-links-title(v-else v-t="'loadGame'")
            .page-game__about-links
              template(v-if="gameLinks.android")
                a(:href="gameLinks.android" target="_blanc")
                  img(src="~/assets/img/google-play.png" alt="google-play" width="185" height="55")
              template(v-if="gameLinks.ios")
                a(:href="gameLinks.ios" target="_blanc")
                  img(src="~/assets/img/appstore.png" alt="appstore" width="162" height="55")
              template(v-if="gameLinks.steam")
                a(:href="gameLinks.steam" target="_blanc")
                  img(src="https://global.battlegrounds.pubg.com/wp-content/themes/regionals/assets/images/play-now/steam.png" alt="steam" width="176" height="55")
              template(v-if="gameLinks.direct")
                a(:href="gameLinks.direct" target="_blanc")
                  Button(is-primary v-t="'loadGame'")
        .page-game__about-right(v-if="youtubeLink")
          a.page-game__about-content(:href="youtubeLink" target="_blank")
            img(src="https://cdn.gaming-goods.com/images/about-game-video.png" alt="video")

      .page-game__block-header
        .page-game__title(v-if="recommendedTournaments.length")
          | {{ $t('recommendedTournaments') }}
      .page-game__tournaments-container
        .page-game__tournaments
          .page-game__tournament(v-for="tournament in recommendedTournaments" :key="tournament.id")
            TournamentCard(:tournament="tournament" :view="cells")

</template>

<script>
import { mapState } from 'vuex'
import PageHead from '~/components/PageHead/PageHead'
import TournamentCard from '~/components/TournamentCard/TournamentCard'
import { createMeta } from '~/utils/meta'
import TournamentsService from '~/services/TournamentsService'
import GamesService from '~/services/GamesService'

export default {
  name: 'PageGame',

  components: { PageHead, TournamentCard },

  fetch ({ store, route, error, i18n }) {
    const game = route.params.game

    if (
      !store.state.games.games.some(item => item.name === game)
    ) {
      return error({ statusCode: 404, message: i18n.t('pageNotFound') })
    }
  },

  data () {
    return {
      recommendedTournaments: []
    }
  },

  computed: {
    ...mapState('games', [
      'gamesByName'
    ]),

    game () {
      return this.gamesByName[this.$route.params.game]
    },

    gameAbout () {
      return GamesService.getGameAbout(this.$route.params.game)
    },

    gameContainer () {
      return this.game.extra_data.game_link
    },

    showBanner () {
      return false
    },

    gameTitle () {
      const locale = this.$i18n.locale?.split?.('-')[0] || 'en'
      return this.gameAbout[locale]?.title
    },

    gameText () {
      const locale = this.$i18n.locale?.split?.('-')[0] || 'en'
      return this.gameAbout[locale]?.text
    },

    gameLinks () {
      return this.gameAbout.links
    },

    gameContent () {
      return this.gameAbout.content
    },

    youtubeLink () {
      return this.gameContent?.youtube
    }
  },

  // mounted () {
  //   this.gameName = this.game.name
  // if (this.gameName === 'pubg-mobile') {
  //   const cookieValue = this.$cookiz.get('modal-pubg-mobile-tdm')
  //   const cookieShouldBe = new Date().toDateString()
  //   if (cookieValue !== cookieShouldBe) {
  //     this.$cookiz.set('modal-pubg-mobile-tdm', cookieShouldBe)
  //     this.showModal({
  //       component: 'ModalPUBGMobileTDM',
  //     })
  //   }
  // }
  // },

  mounted () {
    this.loadRecommendedTournaments()
  },

  methods: {
    loadRecommendedTournaments () {
      TournamentsService.loadRecommendedTournaments(this.$axios, this.game.name).then((response) => {
        this.recommendedTournaments = response.data.data
      }).catch((e) => {
        console.error(
        `${new Date().toUTCString()} :: tournaments recommended fetch error ::`,
        e
        )
      })
    },

    goToBetFury () {
      this.$router.push(this.localeLocation('/betfury'))
    }
  },

  head () {
    const meta = {}
    // switch (this.game.name) {
    //   case 'lichess':
    //     meta.title = this.$t('tournamentsMetaLichessTitle')
    //     meta.description = this.$t('tournamentsMetaLichessDescription')
    //     break
    //   case 'clash-royale':
    //     meta.title = this.$t('tournamentsMetaClashRoyaleTitle')
    //     meta.description = this.$t('tournamentsMetaClashRoyaleDescription')
    //     break
    //   case 'pubg-mobile':
    //     meta.title = this.$t('tournamentsMetaPubgMTitle')
    //     meta.description = this.$t('tournamentsMetaPubgMDescription')
    //     break
    //   case 'brawl-stars':
    //     meta.title = this.$t('tournamentsMetaBrawlStarsTitle')
    //     meta.description = this.$t('tournamentsMetaBrawlStarsDescription')
    //     break
    //   case 'pubg-desktop':
    //     meta.title = this.$t('tournamentsMetaPubgTitle')
    //     meta.description = this.$t('tournamentsMetaPubgDescription')
    //     break
    //   case 'dota2':
    //     meta.title = this.$t('tournamentsMetaDotaTitle')
    //     meta.description = this.$t('tournamentsMetaDotaDescription')
    //     break
    //   case 'free-fire':
    //     meta.title = this.$t('tournamentsMetaFreeFireTitle')
    //     meta.description = this.$t('tournamentsMetaFreeFireDescription')
    //     break
    // }

    meta.title = this.$t('gameAboutPageTitle', { game: this.game.extra_data.full_title })
    meta.description = this.$t('gameAboutPageMetaDescription', { game: this.game.extra_data.full_title })

    meta.sharingDescription = this.$t('platformDescription')

    return createMeta.call(this, meta)
  }
}
</script>

<style scoped lang="scss">
.page-game {
  &__banner {
    margin-top: 117px;
    padding: 20px 16px;
    position: relative;
    border-radius: 16px;
    background: linear-gradient(269.49deg, rgba(36, 20, 33, 0.1) 0%, #2A1422 47.73%, #331524 100%);

    @media (min-width: $breakpointDesktopWide) {
      padding: 32px 40px;
    }

    @media (min-width: $breakpointDesktopWide) {
      padding: 58px 60px;
    }

    &-background {
      position: absolute;
      top: 0;
      right: 0;
      object-fit: cover;
      height: 100%;
    }

    &-logo {
      &--top {
        height: 34px;
        margin-bottom: 16px;

        @media (min-width: $breakpointDesktopWide) {
          display: none;
        }
      }

      &--right {
        display: none;

        @media (min-width: $breakpointDesktopWide) {
          display: block;
          position: absolute;
          top: 25%;
          right: 120px;
          object-fit: cover;
          height: 50%;
        }
      }
    }

    &-title {
      margin-bottom: 32px;
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      color: $white;
      max-width: 617px;

      @media (min-width: $breakpointTablet) {
        font-size: 24px;
        line-height: 32px;
        width: 80%;
      }

      @media (min-width: $breakpointDesktopWide) {
        font-size: 40px;
        line-height: 48px;
        width: 50%;
      }
    }

    &-button {
      color: $white;
      padding: 24px;
      width: 328px;
      z-index: 2;
    }
  }

  &__game-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $blue-grey70;
    margin-bottom: 94px;
    margin-top: 88px;
    max-width: 100%;
    padding: 16px;
    border-radius: 16px;

    @media (min-width: $breakpointTablet) {
      min-height: 700px;
    }
  }

  &__about {
    display: flex;
    flex-direction: column-reverse;
    background-color: $blue-grey70;
    margin-bottom: 94px;
    margin-top: 88px;
    max-width: 100%;
    padding: 16px;
    border-radius: 16px;

    @media (min-width: $breakpointTablet) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 24px;
      padding: 56px;
    }

    &--left {
      max-width: 100%;
    }

    &-title {
      font-style: normal;
      font-weight: 700;
      font-size: 28px;
      line-height: 36px;
      color: $white;
      margin-bottom: 16px;
    }

    &-text {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: $white;
      padding-bottom: 56px;
      margin-bottom: 24px;
      border-bottom: 1px solid $blue-grey40;
    }

    &-links {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: 1fr;

      @media (min-width: $breakpointTablet) {
        grid-template-columns: repeat(2, max-content);
      }

      &-title {
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
        color: $white;
        margin-bottom: 24px;
      }
    }

    &-content {
      cursor: pointer;
    }
  }

  &__tournaments {
    display: grid;
    width: max-content;
    grid-template-columns: repeat(10,1fr);
    grid-gap: 24px;
    user-select: none;
    padding-bottom: 30px;

    &-container {
      overflow: hidden;
    }
  }

  &__block-header {
    width: 100%;
    border-bottom: 1px solid $blue-grey20;
    margin-bottom: 23px;
  }

  &__title {
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    color: $white;
    margin-bottom: 14px;
  }
}
</style>
